import { compareBreakValues } from './breakColumns';
import type {
  PivotCollision,
  PivotFileView,
  PivotSummary,
  PivotedSheet,
} from './types';

function pivotedSheetsFromViews(
  views: readonly PivotFileView[],
): PivotedSheet[] {
  return views.flatMap((view) =>
    view.status === 'pivoted' ? view.sheets : [],
  );
}

function uniqueSorted(values: readonly string[]): string[] {
  return [...new Set(values)].sort(compareBreakValues);
}

export function summarizePivotViews(
  views: readonly PivotFileView[],
): PivotSummary {
  const sheets = pivotedSheetsFromViews(views);
  const collisions: PivotCollision[] = sheets.flatMap(
    (sheet) => sheet.collisions,
  );
  const breakColumns = uniqueSorted(
    sheets.flatMap((sheet) => sheet.breakColumns),
  );
  return {
    fileCount: views.length,
    pivotedSheetCount: sheets.length,
    skippedSheetCount: views.reduce((count, view) => {
      if (view.status === 'pivoted' || view.status === 'unrecognized') {
        return count + view.skippedSheets.length;
      }
      return count;
    }, 0),
    unreadableCount: views.filter((view) => view.status === 'unreadable')
      .length,
    sourceRowCount: sheets.reduce(
      (count, sheet) => count + sheet.sourceRowCount,
      0,
    ),
    itemCount: sheets.reduce((count, sheet) => count + sheet.itemCount, 0),
    breakColumnCount: breakColumns.length,
    multiBreakItemCount: sheets.reduce(
      (count, sheet) => count + sheet.multiBreakItemCount,
      0,
    ),
    collisionCount: collisions.length,
    collisions,
    breakColumns,
  };
}
